import React from 'react';
import useTranslationLgs from '@hooks/i18n/useTranslation';
import { Dialog } from 'primereact/dialog';
import InputYesNoPlain from '../Form/InputYesNoPlain/InputYesNoPlain';
import useForm, { proxiedPropertiesOf } from '@hooks/useForm/useForm';
import { Button } from 'primereact/button';
import { ButtonRow } from '@components/styles';
import HorizontalFieldValue from '@components/obsolete/HorizontalFieldValue.tsx';
import useNavigation from '@hooks/useNavigation';
import * as yup from 'yup';
import { EntityTypeEnum } from '@api/ringil-api.v2.tsx';

interface ComponentProps {
  visible: boolean;
  onCancel: () => void;
  supplierNotificationId: string;
}

interface Form {
  copyAttachments: boolean;
  markAsPrivate: boolean;
}

const SNCreateExpeditionAttachmentDialog: React.FC<ComponentProps> = ({ visible, onCancel, supplierNotificationId }) => {
  const { tr } = useTranslationLgs();
  const navigation = useNavigation();
  const form = useForm<Form>(
    yup.object().shape({}),
    {
      copyAttachments: false,
      markAsPrivate: false,
    },
    data => save(data),
    false,
    false,
  );
  const names = proxiedPropertiesOf<Form>();

  const save = (data: Form) => {
    const markAsPrivate = data.copyAttachments ? data.markAsPrivate : false;
    const queryParams = new URLSearchParams({
      routeAndParameters: 'true',
      cargoAndOrders: 'true',
      documents: 'false',
      labels: 'false',
      internalInfo: 'true',
      carrierSelection: 'true',
      carrierNote: 'true',
      linkToSN: 'true',
      copySNAttachments: data.copyAttachments.toString(),
      markAsPrivate: markAsPrivate.toString(),
    });

    navigation.navigate(
      navigation.urlFunctions.createExpeditionFromEntity(supplierNotificationId, EntityTypeEnum.SUPPLIER_NOTIFICATION, { queryParams })
    );
  };

  return (
    <>
      {/*
        // @ts-ignore*/}
      <Dialog
        visible={visible}
        baseZIndex={1000000}
        onHide={() => onCancel()}
        header={<h4>{tr(`SNCreateExpeditionAttachmentDialog.title`, `Copy attachments from supplier notification?`)}</h4>}
        className="dialog-confirm dialog-md"
      >
        <HorizontalFieldValue
          label={tr(`SNCreateExpeditionAttachmentDialog.copyAttachments`, `Copy attachments`)}
          value={<InputYesNoPlain value={form.values.copyAttachments} onChange={v => form.setFieldValue(names.copyAttachments, v)} />}
        />
        {form.values.copyAttachments && (
          <HorizontalFieldValue
            label={tr(`SNCreateExpeditionAttachmentDialog.markAsPrivate`, `Mark copied attachments as private`)}
            value={<InputYesNoPlain value={form.values.markAsPrivate} onChange={v => form.setFieldValue(names.markAsPrivate, v)} />}
          />
        )}

        <ButtonRow>
          <Button label={tr(`SNCreateExpeditionAttachmentDialog.confirm`, `Continue`)} onClick={() => form.validateAndSend()} data-testid={'sn-createExpedition-attachmentDialog-confirm'} />
          <Button label={tr(`SNCreateExpeditionAttachmentDialog.cancel`, `Cancel`)} className="p-button-text" onClick={() => onCancel()} />
        </ButtonRow>
      </Dialog>
    </>
  );
};

export default SNCreateExpeditionAttachmentDialog;
